// (The MIT License)
// Copyright (c) 2015 Jed Watson.
// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the 'Software'), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// ----------------------------------------------------------------------
/** https://github.com/JedWatson/react-input-autosize */

/**
 * Auto-resizing input field for React
 * A text input for React that resizes itself to the current content.
 * Example:
 *   <AutosizeInput
 *        name="form-field-name"
 *        value={inputValue}
 *        onChange={function(event) {
 *
 *        }}
 *    />
 */
!(function() {
  var React = require('react');
  const { omit } = require('lodash/fp');
  const BrowserUtils = require('share/utils/Izenda.BrowserUtils');
  const browserWidth = 12;
  const addedWidth = 2;
  var sizerStyle = {
    position: 'absolute',
    visibility: 'hidden',
    height: 0,
    whiteSpace: 'pre',
    paddingRight: addedWidth
  };
  const isEdgeOrIE = BrowserUtils.isIEOrEdgeBrowser();
  isEdgeOrIE && (sizerStyle.paddingRight += browserWidth);
  var AutosizeInput = React.createClass({
    propTypes: {
      value: React.PropTypes.any, // field value
      defaultValue: React.PropTypes.any, // default field value
      onChange: React.PropTypes.func, // onChange handler: function(newValue) {}
      style: React.PropTypes.object, // css styles for the outer element
      className: React.PropTypes.string, // className for the outer element
      minWidth: React.PropTypes.oneOfType([
        // minimum width for input element
        React.PropTypes.number,
        React.PropTypes.string
      ]),
      inputStyle: React.PropTypes.object, // css styles for the input element
      inputClassName: React.PropTypes.string // className for the input element
    },
    getDefaultProps: function() {
      return {
        minWidth: 1
      };
    },
    getInitialState: function() {
      return {
        inputWidth: this.props.minWidth
      };
    },
    componentDidMount: function() {
      this.mounted = true; 
      this.copyInputStyles();
      this.updateInputWidth();
    },
    componentDidUpdate: function() {
      this.updateInputWidth();
    },
    componentWillUnmount: function() {
      this.mounted = false;
    },
    copyInputStyles: function copyInputStyles() {
      if (!this.mounted  || !window.getComputedStyle) {
        return;
      }
      var inputStyle = window.getComputedStyle(this.refs.input);
      var widthNode = this.refs.sizer;
      widthNode.style.fontSize = inputStyle.fontSize;
      widthNode.style.fontFamily = inputStyle.fontFamily;
      widthNode.style.fontWeight = inputStyle.fontWeight;
      widthNode.style.fontStyle = inputStyle.fontStyle;
      widthNode.style.letterSpacing = inputStyle.letterSpacing;
      if (this.props.placeholder) {
        var placeholderNode = this.refs.placeholderSizer;
        placeholderNode.style.fontSize = inputStyle.fontSize;
        placeholderNode.style.fontFamily = inputStyle.fontFamily;
        placeholderNode.style.fontWeight = inputStyle.fontWeight;
        placeholderNode.style.fontStyle = inputStyle.fontStyle;
        placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
      }
    },

    updateInputWidth: function updateInputWidth() {
      if (!this.mounted || typeof this.refs.sizer.scrollWidth === 'undefined') {
        return;
      }
      var newInputWidth;
      if (this.props.placeholder) {
        newInputWidth = Math.max(this.refs.sizer.scrollWidth, this.refs.placeholderSizer.scrollWidth) ;
      } else {
        newInputWidth = this.refs.sizer.scrollWidth ;
      }
      if (newInputWidth < this.props.minWidth) {
        newInputWidth = this.props.minWidth;
      }
      if (newInputWidth !== this.state.inputWidth) {
        this.setState({
          inputWidth: newInputWidth
        });
      }
    },
    getInput: function getInput() {
      return this.refs.input;
    },
    focus: function focus() {
      this.refs.input.focus();
    },
    blur: function blur() {
      this.refs.input.blur();
    },
    select: function select() {
      this.refs.input.select();
    },
    render: function() {
      var value = this.props.defaultValue || this.props.value || '';
      var rest = omit(['inputClassName', 'inputStyle', 'minWidth', 'style'], this.props);

      var wrapperStyle = this.props.style || {};
      if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
      var inputStyle = this.props.inputStyle || {};
      inputStyle.width = this.state.inputWidth;
      inputStyle.boxSizing = 'content-box';

      var placeholder = this.props.placeholder ? (
        <div ref="placeholderSizer" style={sizerStyle}>
          {this.props.placeholder}
        </div>
      ) : null;

      return (
        <div className={this.props.className} style={wrapperStyle}>
          <input type="text" {...rest} ref="input" className={this.props.inputClassName} style={inputStyle} />
          <div ref="sizer" style={sizerStyle} >
            {value}
          </div>
          {placeholder}
        </div>
      );
    }
  });

  module.exports = AutosizeInput;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.AutosizeInput.jsx